import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["profileMenu"];

  connect() {}

  toggleProfile() {
    this.profileMenuTarget.classList.toggle("hidden");
  }
}
